<div class="modal-header">
    <div class="col-md-10 input-group">

        <h3 class="modal-title text-modal-header-bold" id="modal-basic-title"> Detalle de comprobante &nbsp;&nbsp;
        </h3>
        <button *ngIf="actDam" type="button" class="btn btn-info mr-3 btn-rounded" (click)="openModalDam()">
            Actualizar DAM </button>

        <button *ngIf="enDoc" type="button" class="btn btn-secondary m-b-15 btn-rounded" (click)="imprimir()"><i
                class="fa fa-print"></i>&nbsp;
            Imprimir </button>

        <button *ngIf="traz" type="button" class="btn btn-rounded btn-secondary m-b-15" (click)="trazabilidad()"><i
                class="fa fa-copy"></i>&nbsp;
            Trazabilidad </button>

        <div *ngIf="(documento.situacfe != 0)" class="btn-group dropright m-b-15" ngbDropdown container="body"
            role="group" aria-label="Button group with nested dropdown">
            <button class="btn btn-rounded btn-secondary mr-3" ngbDropdownToggle>
                <i class="fas fa-list-alt mr-1"></i>
                Acciones
            </button>

            <div class="dropdown-menu" ngbDropdownMenu>
                <button *ngIf="(documento.situacfe != 0)" class="dropdown-item" (click)="download_xml(documento)">
                    <i class="fa fas fa-download font-14"></i>
                    Descargar XML
                </button>
                <button *ngIf="(documento.situacfe != 0)" class="dropdown-item" (click)="download_cdr(documento)">
                    <i class="fa fas fa-download font-14"></i>
                    Descargar CDR
                </button>
                <button *ngIf="(documento.situacfe != 0 && documento.situac == 'F')" class="dropdown-item"
                    (click)="enviarCorreo(documento)">
                    <i class="far fa-envelope-open font-14"></i>
                    Enviar por correo
                </button>
            </div>
        </div>
        <div *ngIf="documento.tipdoc==1 || documento.tipdoc==3 || documento.tipdoc==7 || documento.tipdoc==8"
            class="btn-group dropright m-b-10" ngbDropdown container="body" role="group"
            aria-label="Button group with nested dropdown">
            <button class="btn btn-rounded btn-secondary mr-3" ngbDropdownToggle>
                <i class="fas fa-list-alt mr-1"></i> Contabilidad
            </button>

            <div class="dropdown-menu" ngbDropdownMenu>
                <button class="dropdown-item" (click)="imprimirAsientoProceso(documento)">
                    <i class="fa fas fa-copy font-14"></i> Imprimir asiento en proceso</button>
                <button class="dropdown-item" (click)="imprimirAsientoContabilizado(documento)">
                    <i class="fa fas fa-copy font-14"></i> Imprimir asiento contabilizado</button>
            </div>
        </div>
        <button *ngIf="validarTipoDocumento()" type="button" class="btn btn-rounded btn-secondary m-b-15"
            (click)="obtenerCuentaPorCobrar()">
            <i class="fas fa-coins font-14"></i>&nbsp;
            Cuenta por cobrar
        </button>
    </div>
    <button (keydown.tab)="onNexFocus('nuevo')" type="button" class="close" aria-label="Close" (click)="cerrar()"
        tabindex="13">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">

    <div class="row">

        <div class="col-lg-12">
            <div class="form-row">

                <div class="col-md-6">
                    <div class="form-group border-consulta">
                        <label class="form-control-label tamano-consulta">Documento</label>
                        <div class="input-group">
                            <input class="form-control  m-r-5 col-md-2 tsiInput" id="codTipoDocumento"
                                name="codTipoDocumento" [disabled]="!encontrado" type="text" tabindex="201"
                                [(ngModel)]="documento.tipdoc" style="text-align: center !important;">

                            <select style="color: black !important;"
                                class="col-md-10 focus-input input_border tsiSelect select_border"
                                [disabled]="!encontrado" id="cboTipoDocumentoTabla" name="tipdoc"
                                [(ngModel)]="documento.tipdoc">
                                <option *ngFor="let lst of tiposDocumentos" value="{{lst.tipdoc}}">{{lst.descri}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-md-4" style="padding-left: 30px;">
                    <div class="form-group  border-consulta">
                        <label class="form-control-name mr-2">Serie - Nro:</label>
                        <div class="input-group">
                            <input type="text" class="form-control  m-r-5 col-md-4  tsiInput" name="codInterlocutor"
                                [(ngModel)]="documento.series" [disabled]="!encontrado" tabindex="202">

                            <input type="text" class="form-control  m-r-5 col-md-4  tsiInput"
                                [(ngModel)]="documento.numdoc" [disabled]="!encontrado" name="interlocutor"
                                id="interlocutor" tabindex="203">
                        </div>


                    </div>
                </div>
                <div class="col-md-2" style="padding-left: 30px;">
                    <div class="form-group  border-consulta">
                        <label class="form-control-name mr-2">Tipo de cambio:</label>
                        <div class="input-group">
                            <input type="text" class="form-control  m-r-5 col-md-10  tsiInput" name="codInterlocutor"
                                [(ngModel)]="documento.tipcam" [disabled]="!encontrado" tabindex="202">
                        </div>
                    </div>

                    <div *ngIf="encontrado" class="col-md-2" style="padding-left: 30px;">
                        <button type="button" class="mr-4 btn btn-rounded btn-info" (click)="consultar()"><i
                                tabindex="4" class="fa fa-search"></i>
                            Buscar </button>
                    </div>


                </div>
            </div>
            <div class="col-lg-12">

                <div class="card">
                    <div *ngIf="documento.comprobanteOrigen != null" class="card-body"
                        style="border-top: 1.5px solid rgb(145, 145, 148) !important;">
                        <label class="form-control-label tamano-consulta" style="margin-left: -20px;">Datos del
                            comprobante origen </label>
                        <div class="row" style="padding-bottom: 0px;">

                            <div class="col-md-6" aria-autocomplete="none">
                                <div class="form-group row" style="margin-bottom: 0px !important;">

                                    <label for="serie"
                                        class="col-sm-2 text-left control-label col-form-label tsiLabel">T.Documento:
                                    </label>
                                    <div class="col-sm-2">
                                        <input class="form-control  m-r-5 tsiInput" id="codTipoDocumento"
                                            name="codTipoDocumento" [disabled]="!encontrado" type="text" tabindex="201"
                                            [(ngModel)]="documento.comprobanteOrigen.tipdoc"
                                            style="text-align: center !important;">
                                    </div>
                                    <div class="col-sm-8">
                                        <select style="color: black !important;"
                                            class=" custom-select form-control  select_border tsiSelect"
                                            [disabled]="!encontrado" id="codTipoDocumento" name="codTipoDocumento"
                                            [(ngModel)]="documento.comprobanteOrigen.tipdoc">
                                            <option *ngFor="let lst of tiposDocumentos" value="{{lst.tipdoc}}">
                                                {{lst.descri}}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-group row" style="margin-bottom: 0px !important;">
                                    <label for="serie"
                                        class="col-sm-2 text-left control-label col-form-label tsiLabel">Serie :
                                    </label>
                                    <div class="col-sm-2">
                                        <input tabindex="7" style="text-align: center;" disabled
                                            class="focus-input input_border form-control  tsiInput" id="codserie"
                                            name="codserie" [(ngModel)]="documento.comprobanteOrigen.series" type="text"
                                            maxlength="4" tabindex="1">
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6" aria-autocomplete="none">
                                <div class="form-group row" style="margin-bottom: 0px !important;">
                                    <label for="serie"
                                        class="col-sm-2 text-left control-label col-form-label tsiLabel">Fecha :
                                    </label>
                                    <div class="col-sm-4">
                                        <input tabindex="7" style="text-align: center;" disabled
                                            class="focus-input input_border form-control  tsiInput" id="codserie"
                                            name="codserie" [(ngModel)]="documento.comprobanteOrigen.femisi" type="date"
                                            maxlength="4" tabindex="1">
                                    </div>
                                </div>

                                <div class="form-group row" style="margin-bottom: 0px !important;">
                                    <label for="serie"
                                        class="col-sm-2 text-left control-label col-form-label tsiLabel">Tipo cambio :
                                    </label>
                                    <div class="col-sm-2">
                                        <input tabindex="7" style="text-align: center;" disabled
                                            class="focus-input input_border form-control  tsiInput" id="codserie"
                                            name="codserie" [(ngModel)]="documento.comprobanteOrigen.tipcam" type="text"
                                            maxlength="4" tabindex="1">
                                    </div>

                                    <label for="serie"
                                        class="col-sm-2 text-right control-label col-form-label tsiLabel">IGV :
                                    </label>
                                    <div class="col-sm-2">
                                        <input tabindex="7" style="text-align: center;" disabled
                                            class="focus-input input_border form-control  tsiInput" id="codserie"
                                            name="codserie" [(ngModel)]="documento.comprobanteOrigen.porigv" type="text"
                                            maxlength="4" tabindex="1">
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div [hidden]="formulario" class="card-body"
                        style="border-top: 1.5px solid rgb(145, 145, 148) !important;">
                        <div class="row" style="padding-bottom: 0px;">
                            <div class="col-md-6" aria-autocomplete="none">
                                <div class="form-group row" style="margin-bottom: 0px !important;">

                                    <label for="serie"
                                        class="col-sm-2 text-left control-label col-form-label tsiLabel">Serie - Nro :
                                    </label>

                                    <div class="col-sm-2">
                                        <input tabindex="7" style="text-align: center;" disabled
                                            class="focus-input input_border form-control  tsiInput" id="codserie"
                                            name="codserie" [(ngModel)]="documento.series" type="text" maxlength="4"
                                            tabindex="1"
                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                                    </div>
                                    <div class="col-sm-2">
                                        <input tabindex="7" style="text-align: center;" disabled
                                            class="focus-input input_border form-control  tsiInput" id="codserie1"
                                            name="codserie1" [(ngModel)]="documento.numdoc" type="text" maxlength="4"
                                            tabindex="1"
                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                                    </div>

                                    <label class="col-sm-2 form-control-name ml-3"
                                        style="font-weight:bold;">Numint:</label>
                                    <div class="col-sm-2">
                                        <input tabindex="7" style="text-align: center;font-weight:bold;" disabled
                                            class="focus-input input_border form-control  tsiInput" id="numint"
                                            name="numint" [(ngModel)]="documento.numint" type="text">
                                    </div>

                                </div>

                                <div class="form-group row" style="margin-bottom: 0px !important;">
                                    <label
                                        class="col-sm-2 text-left control-label col-form-label tsiLabel">Cliente:</label>

                                    <div class="col-sm-2">
                                        <input disabled type="text"
                                            class="focus-input input_border tsiInput form-control " id="codCliente"
                                            name="codCliente" [(ngModel)]="documento.codcli" type="text" tabindex="3"
                                            placeholder="-1" style="text-align: left !important;">
                                    </div>

                                    <input disabled class="focus-input input_border form-control tsiInput col-md-7"
                                        id="tipoCliente" name="tipoCliente" [(ngModel)]="documento.razonc" tabindex="4"
                                        type="text" style="margin-left: 10px !important;">

                                </div>

                                <div class="form-group row" style="margin-bottom: 0px !important;">

                                    <label for="moneda"
                                        class="col-sm-2 text-left control-label col-form-label tsiLabel">Ruc/DNI/CE :
                                    </label>

                                    <div class="col-sm-4">
                                        <input tabindex="7" style="text-align: left;"
                                            class="focus-input input_border form-control  tsiInput" id="codRdc"
                                            name="codRdc" [(ngModel)]="documento.ruc" disabled tabindex="6" type="text"
                                            maxlength="4"
                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                                    </div>
                                </div>

                                <div class="form-group row" style="margin-bottom: 0px !important;">

                                    <label class="col-sm-2 text-left control-label col-form-label tsiLabel">Direccion
                                        :</label>
                                    <input disabled class="focus-input input_border form-control tsiInput col-md-9"
                                        id="direccion" name="direccion" [(ngModel)]="documento.direc1" tabindex="4"
                                        type="text" style="margin-left: 10px !important;">
                                </div>

                                <!-- <div class="form-group col" style="margin-bottom: 0px !important;"> -->

                                <div class="form-group row" style="margin-bottom: 0px !important;">
                                    <label class="col-sm-2 text-left control-label col-form-label tsiLabel">Vendedor
                                        :</label>
                                    <div class="col-sm-2">
                                        <input tabindex="7" style="text-align: center;" disabled
                                            class="focus-input input_border tsiInput form-control " id="codvendedor"
                                            name="codvendedor" [(ngModel)]="documento.codven" type="text" maxlength="4"
                                            tabindex="1"
                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                                    </div>
                                    <div class="col-sm-7">
                                        <input tabindex="7" style="text-align: left;" disabled
                                            class="focus-input input_border form-control  tsiInput" id="vendedor"
                                            name="vendedor" [(ngModel)]="documento.desven" type="text" maxlength="4"
                                            tabindex="1"
                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                                    </div>
                                </div>

                                <div class="form-group row" style="margin-bottom: 0px !important;">
                                    <label class="col-sm-2 text-left control-label col-form-label tsiLabel">Usuario
                                        :</label>
                                    <div class="col-sm-2">
                                        <input tabindex="7" style="text-align: center;" disabled
                                            class="focus-input input_border form-control  tsiInput" id="codUsuario"
                                            name="codUsuario" [(ngModel)]="documento.usuari" type="text" maxlength="4"
                                            tabindex="1"
                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                                    </div>
                                    <div class="col-sm-7">
                                        <input tabindex="7" style="text-align: left;" disabled
                                            class="focus-input input_border form-control  tsiInput" id="usuario"
                                            name="usuario" [(ngModel)]="documento.descusuario" type="text" maxlength="4"
                                            tabindex="1"
                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                                    </div>
                                </div>

                                <div class="form-group row" style="margin-bottom: 0px !important;">
                                    <label class="col-sm-2 text-left control-label col-form-label tsiLabel">Fecha de
                                        entrega:</label>
                                    <div class="col-sm-3">
                                        <input tabindex="7" disabled
                                            class=" focus-input input_border form-control  tsiInput" id="fechEntrega"
                                            style="text-align: center;" name="fechEntrega"
                                            [(ngModel)]="documento.fentreg" type="date" maxlength="4" tabindex="1">
                                    </div>

                                    <label class="col-sm-2 text-left control-label col-form-label tsiLabel">Fecha de
                                        Fact.:</label>
                                    <div class="col-sm-3">
                                        <input tabindex="7" disabled
                                            class="focus-input input_border form-control  tsiInput" id="ffacpro"
                                            style="text-align: center;" name="ffacpro" [(ngModel)]="documento.ffacpro"
                                            type="date" maxlength="4" tabindex="1"
                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                                    </div>
                                    <!-- </div> -->

                                </div>
                                <div class="form-group row" style="margin-bottom: 0px !important;">

                                    <label for="comentario"
                                        class="col-sm-2 text-left control-label col-form-label tsiLabel">Comentario :
                                    </label>

                                    <div class="col-sm-10">
                                        <input tabindex="7" style="text-align: left;"
                                            class="focus-input input_border form-control  tsiInput" id="comentario"
                                            name="comentario" [(ngModel)]="documento.presen" disabled type="text">
                                    </div>
                                </div>




                            </div>
                            <div class="col-md-6" aria-autocomplete="none">
                                <div class="form-group row" style="margin-bottom: 0px !important;">
                                    <label class="col-sm-2 text-left control-label col-form-label tsiLabel">Fecha
                                        emisión:</label>

                                    <div class="col-sm-3">
                                        <input disabled type="text" disabled
                                            class="focus-input input_border tsiInput form-control " id="fechEmision"
                                            name="fechEmision" [(ngModel)]="documento.femisi" type="date" tabindex="3"
                                            placeholder="-1" style="text-align: center !important;">
                                    </div>

                                    <label for="serie"
                                        class="col-sm-2 text-right control-label col-form-label tsiLabel">Hora
                                        :
                                    </label>

                                    <div class="col-sm-2">
                                        <input tabindex="7" style="text-align: center;" disabled
                                            class="focus-input input_border form-control  tsiInput" id="hora"
                                            name="hora" [(ngModel)]="documento.hcreac" type="text" maxlength="4"
                                            tabindex="1">
                                    </div>
                                </div>
                                <div class="form-group row" style="margin-bottom: 0px !important;">

                                    <label class="col-sm-2 text-left control-label col-form-label tsiLabel">Inc. I.G.V.
                                        :</label>
                                    <label class="col-sm-1 text-left control-label col-form-label tsiLabel">
                                        <input disabled class="form-check-input-local radio-inline" type="radio"
                                            name="IncIgv" [(ngModel)]="documento.incigv" value="S">&nbsp;Si
                                    </label>
                                    <label class="col-sm-1 text-left control-label col-form-label tsiLabel">
                                        <input disabled class="form-check-input-local radio-inline" type="radio"
                                            name="IncIgv" [(ngModel)]="documento.incigv" value="N">&nbsp;No
                                    </label>
                                </div>
                                <div class="form-group row" style="margin-bottom: 0px !important;">

                                    <label class="col-sm-2 text-left control-label col-form-label tsiLabel">Venta
                                        :</label>

                                    <label class=" col-sm-2 text-left control-label col-form-label tsiLabel">
                                        <input disabled class="form-check-input-local radio-inline" type="radio"
                                            name="venta" [(ngModel)]="documento.destin" value=1> Nacional
                                    </label>
                                    <label class=" col-sm-2 text-left control-label col-form-label tsiLabel">
                                        <input disabled class="form-check-input-local radio-inline" type="radio"
                                            name="venta" [(ngModel)]="documento.destin" value=2> Exportación
                                    </label>
                                    <label class=" col-sm-2 text-left control-label col-form-label tsiLabel">
                                        <input disabled class="form-check-input-local radio-inline" type="radio"
                                            name="venta1" [(ngModel)]="documento.id" value="I"> Ingreso
                                    </label>
                                    <label class=" col-sm-2 text-left control-label col-form-label tsiLabel">
                                        <input disabled class="form-check-input-local radio-inline" type="radio"
                                            name="venta1" [(ngModel)]="documento.id" value="S"> Salida
                                    </label>

                                    <!--  <label class="col-sm-2 text-left control-label col-form-label tsiLabel">
                        <input class="form-check-input radio-inline" type="radio" name="venta"
                            [(ngModel)]="obj.venta" value="true">Nacional
                        </label>
                        <label class="col-sm-2 text-left control-label col-form-label tsiLabel">
                        <input class="form-check-input radio-inline" type="radio" name="venta"
                            [(ngModel)]="obj.venta" value="false">Exportación
                        </label> -->
                                </div>
                                <div class="form-group row" style="margin-bottom: 0px !important;">

                                    <label for="moneda"
                                        class="col-sm-2 text-left control-label col-form-label tsiLabel">Cond. pago :
                                    </label>

                                    <div class="col-sm-2">
                                        <input tabindex="7" style="text-align: center;"
                                            class="focus-input input_border form-control  tsiInput" id="codConpago"
                                            name="codConpago" [(ngModel)]="documento.codcpag" disabled tabindex="6"
                                            type="text" maxlength="4"
                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                                    </div>
                                    <input disabled class="focus-input input_border form-control tsiInput col-md-6"
                                        id="conPago" name="conPago" [(ngModel)]="documento.descodcpag" tabindex="4"
                                        type="text" style="margin-left: 10px !important;">
                                </div>

                                <div class="form-group row" style="margin-bottom: 0px !important;">

                                    <label class="col-sm-2 text-left control-label col-form-label tsiLabel">Motivo
                                        :&nbsp;</label>
                                    <div class="col-sm-2">
                                        <input tabindex="7" style="text-align: center;"
                                            class="focus-input input_border form-control  tsiInput" id="codConpago"
                                            name="codConpago" [(ngModel)]="documento.codmot" disabled tabindex="6"
                                            type="text" maxlength="4"
                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                                    </div>
                                    <input disabled class="focus-input input_border form-control tsiInput col-md-6"
                                        id="conPago" name="conPago" [(ngModel)]="documento.desmot" tabindex="4"
                                        type="text" style="margin-left: 10px !important;">


                                </div>

                                <!-- <div class="form-group row" style="margin-bottom: 0px !important;"> -->


                                <div class="form-group row" style="margin-bottom: 0px !important;">
                                    <label class="col-sm-2 text-left control-label col-form-label tsiLabel">Situación
                                        :</label>
                                    <div class="col-sm-4">
                                        <input tabindex="7" style="text-align: center;" disabled
                                            class="focus-input input_border form-control tsiInput" id="situacion"
                                            name="situacion" [(ngModel)]="documento.dessituac" type="text" maxlength="4"
                                            tabindex="1"
                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                                    </div>


                                    <label class="col-sm-2 text-right control-label col-form-label tsiLabel">Moneda
                                        :</label>
                                    <div class="col-sm-2">
                                        <input tabindex="7" style="text-align: center;" disabled
                                            class="focus-input input_border form-control tsiInput" id="moneda"
                                            name="moneda" [(ngModel)]="documento.tipmon" type="text" maxlength="4"
                                            tabindex="1"
                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                                    </div>
                                </div>

                                <div class="form-group row" style="margin-bottom: 0px !important;">
                                    <label class="col-sm-2 text-left control-label col-form-label tsiLabel">Observación
                                        :&nbsp;</label>
                                    <div class="col-sm-9">
                                        <textarea disabled style="margin-right: 10px !important; max-height: 150px;"
                                            class="focus-input input_border form-control   input_border" rows="3"
                                            name="observacion" maxlength="500" [(ngModel)]="documento.observ"
                                            tabindex="28"></textarea>
                                    </div>

                                </div>

                                <div class="form-group row mt-3" style="margin-bottom: 0px !important;">
                                    <label class="col-sm-2 text-left control-label col-form-label tsiLabel">Estado
                                        :</label>
                                    <div class="col-sm-6">
                                        <input tabindex="7" style="text-align: center;" disabled
                                            class="focus-input input_border form-control tsiInput" id="situacion"
                                            name="situacion" [(ngModel)]="documento.estadofe"
                                            [ngClass]="{'classbaja': documento.estadofe === 'Dado de baja','classNoEnviado': documento.estadofe === 'No enviado', 'classbajares':documento.estadofe === 'Dado de baja-res' , 'classbajaxSunat':documento.estadofe === 'Dado de Baja por Sunat', 'classRechazado':documento.estadofe === 'Rechazado','classObservado':documento.estadofe === 'Observado' }"
                                            type="text" maxlength="4">
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <br>
                </div>
                <div class="card-body" style="border-top: 1.5px solid rgb(145, 145, 148) !important;">

                    <div class="table-responsive" style="max-height: 350px !important;">
                        <table id="frmDetalleComprobante"
                            class="table table-sm table-striped table-bordered table-hover">
                            <thead>
                                <tr>

                                    <th id="" style="white-space: nowrap;"> </th>
                                    <th id="item" style="white-space: nowrap; width: 100px;">Item </th>
                                    <th id="tInv" style="white-space: nowrap;" style="text-align: left;"> T.inv </th>

                                    <th id="codArt" style="white-space: nowrap !important;"> Código Artículo </th>
                                    <th id="desArt" style="white-space: nowrap;" style="text-align: center;">Descripción
                                        de artículo</th>
                                    <!-- <th style="white-space: nowrap;" style="text-align: left;">Cod.Calid</th> -->
                                    <th id="etiqueta" style="white-space: nowrap;" style="text-align: left;"> Etiqueta
                                    </th>
                                    <th id="chasis" style="white-space: nowrap;" style="text-align: left;"> Chasis </th>
                                    <!-- <th style="white-space: nowrap;" style="text-align: left;"> Cod.Color </th> -->
                                    <th id="motor" style="white-space: nowrap;" style="text-align: left;"> Motor </th>
                                    <th id="cantidad" style="white-space: nowrap;" style="text-align: right;"> Cantidad
                                    </th>
                                    <th id="preUni" style="white-space: nowrap;" style="text-align: right;"> Precio
                                        Unitario </th>
                                    <th id="desc1" style="white-space: nowrap;" style="text-align: left;"> Desc. 1 </th>
                                    <th id="desc2" style="white-space: nowrap;" style="text-align: left;"> Desc. 2 </th>
                                    <th id="desc3" style="white-space: nowrap;" style="text-align: left;"> Desc. 3 </th>
                                    <th id="desc4" style="white-space: nowrap;" style="text-align: left;">Desc. 4</th>
                                    <th id="precTotal" style="white-space: nowrap;" style="text-align: left;">Precio
                                        total</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let lst of documento.detalle; let i = index">
                                    <!--<td style="text-align: center;">
                                <input type="radio" (change)="onChangeCotizacion(lst)" tabindex="13" name="radio">
                            </td> -->
                                    <td style="text-align: center;">

                                        <div class="btn-group dropright" ngbDropdown container="body" role="group"
                                            aria-label="Button group with nested dropdown"
                                            style="margin: 0px; padding: 0px;">
                                            <button class="btn btn-sm" ngbDropdownToggle
                                                style="margin: 0px; padding: 0px;">
                                                <i class=" fas fa-align-left"></i>
                                            </button>
                                            <div class="dropdown-menu" ngbDropdownMenu>
                                                <!-- <button *ngIf="lst.tipdoc == 100 " class="dropdown-item"
                                            (click)="imprimir(lst)"><i class="fa fa-print font-14"
                                                style="margin-right: .3rem"></i>
                                            Imprimir A4
                                        </button>
                                        <button *ngIf="lst.tipdoc == 100 " class="dropdown-item"
                                            (click)="imprimir_desc(lst)"><i class="fa fa-print font-14"
                                                style="margin-right: .3rem"></i>
                                            Imprimir A4 con descuento</button>
                                        <button *ngIf="lst.tipdoc == 100 " class="dropdown-item"
                                            (click)="imprimir_ticket(lst)"><i class="fa fa-print font-14"
                                                style="margin-right: .3rem"></i>
                                            Imprimir ticket</button>
                                        <button *ngIf="lst.tipdoc == 102" class="dropdown-item"
                                            (click)="imprimirguiarem(lst)"><i class="fa fa-print font-14"
                                                style="margin-right: .3rem"></i>
                                            Imprimir A4
                                        </button>
                                        <button *ngIf="lst.tipdoc == 101" class="dropdown-item"
                                            (click)="imprimir(lst)"><i class="fa fa-print font-14"
                                                style="margin-right: .3rem"></i>
                                            Imprimir A4
                                        </button>
                                        <button *ngIf="lst.tipdoc == 101" class="dropdown-item"
                                            (click)="imprimir_desc(lst)"><i class="fa fa-print font-14"
                                                style="margin-right: .3rem"></i>
                                            Imprimir A4 con descuento</button>
                                        <button *ngIf="lst.tipdoc != 101 && lst.tipdoc != 100 && lst.tipdoc != 102"
                                            class="dropdown-item" (click)="downloadPDF(lst)" n><i
                                                class="fa fa-print font-14" style="margin-right: .3rem"></i>
                                            Imprimir </button> -->

                                                <button class="dropdown-item" (click)="actaEntrega(lst)"><i
                                                        class="fas fa-copy font-14" style="margin-right: .3rem"></i>
                                                    Acta de entrega</button>
                                                <button
                                                    *ngIf="lst.etiqueta != null && lst.nrocarrete != null && lst.acabado != null"
                                                    class="dropdown-item" (click)="actualizarPlaca(lst)"><i
                                                        class="fas fa-copy font-14" style="margin-right: .3rem"></i>
                                                    Actualizar placa</button>

                                            </div>

                                        </div>

                                    </td>

                                    <td style="text-align: center; white-space: nowrap !important;"> {{lst.numite}}
                                    </td>
                                    <td style="text-align: right; white-space: nowrap !important;"> {{lst.tipinv}} </td>
                                    <td style="text-align: left; white-space: nowrap !important;"> {{lst.codart}} </td>
                                    <td style="text-align: left; white-space: nowrap !important;"> {{lst.desart}} </td>
                                    <td style="text-align: left; white-space: nowrap !important;"> {{lst.etiqueta}}
                                    </td>
                                    <td style="text-align: left; white-space: nowrap !important;"> {{lst.chasis}} </td>
                                    <td style="text-align: left; white-space: nowrap !important;"> {{lst.motor}} </td>
                                    <td style="text-align: right; white-space: nowrap !important;"> {{lst.cantid}} </td>
                                    <td style="text-align: right; white-space: nowrap !important;"> {{lst.preuni }}
                                    </td>
                                    <td style="text-align: right; white-space: nowrap !important;">{{lst.pordes1}}</td>
                                    <td style="text-align: right; white-space: nowrap !important;">{{lst.pordes2}} </td>
                                    <td style="text-align: right; white-space: nowrap !important;">{{lst.pordes3}} </td>
                                    <td style="text-align: right; white-space: nowrap !important;">{{lst.pordes4 }}
                                    </td>
                                    <td style="text-align: right; white-space: nowrap !important;">{{lst.importe }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <hr>
                <!-- <div class="row col-sm-12 justify-content-center" style="margin-left: 3px !important;"
            aria-autocomplete="none">
            <div class="input-group">

                <label *ngIf="codAlmacen != -1 && codArticulo != '-1' && codArticulo != '' && check != true"
                    style="margin-top: -3px; margin-right: 5px;"
                    class="text-left control-label col-form-label tsiLabel">Stock inicial:
                </label>
                <input *ngIf="codAlmacen != -1 && codArticulo != '-1' && codArticulo != '' && check != true "
                    tabindex="7" class="form-control  tsiInput" [(ngModel)]="viewStockIni" disabled
                    style="margin-right: 3px;">

                <label style="margin-top: -3px;  margin-right: 5px;"
                    class="text-left control-label col-form-label tsiLabel">Ingresos:
                </label>
                <input tabindex="7" class="form-control  tsiInput" [(ngModel)]="viewIngresos"
                    disabled style="margin-right: 3px;">

                <label style="margin-top: -3px;  margin-right: 5px;"
                    class="text-left control-label col-form-label tsiLabel">Salidas:
                </label>
                <input tabindex="7" class="form-control  tsiInput" [(ngModel)]="viewSalidas" disabled
                    style="margin-right: 3px;">

                <label style="margin-top: -3px;  margin-right: 5px;"
                    class="text-left control-label col-form-label tsiLabel">Stock
                    final:
                </label>
                <input tabindex="7" class="form-control  tsiInput" [(ngModel)]="viewStockfinal"
                    disabled style="margin-right: 3px;">


            </div>
        </div> -->
            </div>


        </div>

    </div>
</div>